import { render, staticRenderFns } from "./zhihuinongye.vue?vue&type=template&id=ad4f1926&scoped=true&"
import script from "./zhihuinongye.vue?vue&type=script&lang=js&"
export * from "./zhihuinongye.vue?vue&type=script&lang=js&"
import style0 from "./zhihuinongye.vue?vue&type=style&index=0&id=ad4f1926&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad4f1926",
  null
  
)

export default component.exports